export default {"src":"/_next/static/media/cg.79296328.svg","height":27,"width":41};